import { REACT_APP_BACKEND_URL } from '../utils/constants';
import { SseNotificationEvent } from '../types/notification';

export function connectNotificationStream(
  token: string,
  onMessage: (event: SseNotificationEvent) => void,
  onError: (event: Event) => void,
): EventSource {
  const url = `${REACT_APP_BACKEND_URL}/notification/stream?token=${encodeURIComponent(token)}`;
  const source = new EventSource(url);

  source.onmessage = (e) => {
    try {
      const data: SseNotificationEvent = JSON.parse(e.data);
      onMessage(data);
    } catch {
      // Ignore malformed messages
    }
  };

  source.onerror = onError;

  return source;
}
